// @flow

import { type LookAndFeel } from '@tectonics/look-and-feel';

const volcanes: LookAndFeel = {
  code: 'volcanes',
  displayName: 'Volcanes',
  getRootComponent: () => import('./volcanes'),
  getLoadingPage: () => import('@tectonics/components/loading-page'),
  prsSupport: {
    integrations: {
      br: ['creditcard', 'debitcard', 'pix', 'boleto', 'banktransfer', 'tef', 'google', 'ewallet'],
      mx: ['creditcard', 'debitcard', 'oxxo', 'spei', 'oxxopay', 'ewallet'],
      ar: ['creditcard', 'debitcard', 'ewallet', 'cash'],
      co: ['creditcard', 'baloto', 'eft', 'cash', 'ewallet'],
      pe: ['creditcard', 'pagoefectivo', 'safetypay'],
      cl: ['creditcard', 'multicaja', 'webpay', 'sencillito', 'servipag'],
      bo: ['cash'],
      ec: ['safetypay-cash', 'safetypay-online'],
      uy: ['creditcard', 'debitcard'],
    },
    features: [
      { name: 'field_customer_name' },
      { name: 'field_brazilian_document',
        traits: ['type_cpf', 'type_cnpj'] },
      { name: 'field_customer_email' },
      { name: 'field_brazilian_zipcode' },
      { name: 'field_brazilian_phone_number' },
      { name: 'field_brazilian_state' },
      { name: 'field_brazilian_city' },
      { name: 'field_brazilian_address' },
      { name: 'field_brazilian_street_number' },
      { name: 'field_brazilian_street_complement' },
      { name: 'field_mexican_zipcode' },
      { name: 'field_mexican_phone_number' },
      { name: 'field_mexican_state' },
      { name: 'field_mexican_city' },
      { name: 'field_mexican_address' },
      { name: 'field_mexican_street_number' },
      { name: 'field_mexican_street_complement' },
      { name: 'field_argentine_document' },
      { name: 'field_argentine_document_type' },
      { name: 'field_argentine_zipcode' },
      { name: 'field_argentine_phone_number' },
      { name: 'field_argentine_state' },
      { name: 'field_argentine_city' },
      { name: 'field_argentine_address' },
      { name: 'field_argentine_street_number' },
      { name: 'field_argentine_street_complement' },
      { name: 'field_argentine_cash_bank_list' },
      {
        name: 'display_argentine_accepts_cash_methods',
        traits: ['rapipago', 'pagofacil', 'cupon'],
      },
      { name: 'display_receipt_argentine_tax_iva' },
      { name: 'display_receipt_argentine_tax_ip' },
      { name: 'display_receipt_argentine_tax_ig_ibp' },
      { name: 'field_card_holder_name' },
      { name: 'field_card_number' },
      { name: 'field_card_expiry_date' },
      { name: 'field_card_security_code' },
      { name: 'field_card_instalments' },
      { name: 'field_accept_visa_terms' },
      { name: 'field_tef_select_bank' },
      { name: 'display_merchant_logo' },
      { name: 'display_receipt_original_amount' },
      { name: 'display_receipt_fx_rate' },
      { name: 'display_receipt_brazilian_tax_iof' },
      { name: 'display_receipt_final_amount' },
      { name: 'display_selected_instalment' },
      { name: 'display_boleto_total_value' },
      { name: 'display_boleto_due_date' },
      { name: 'display_boleto_barcode' },
      { name: 'display_boleto_number' },
      { name: 'display_boleto_tips' },
      { name: 'action_boleto_copy_code' },
      { name: 'action_boleto_save_pdf' },
      { name: 'display_boleto_email_warning' },
      { name: 'action_oxxo_save_pdf' },
      { name: 'display_oxxo_success_message' },
      { name: 'display_oxxo_number' },
      { name: 'display_oxxo_instructions' },
      { name: 'display_oxxo_payment_locations' },
      { name: 'display_oxxo_ticket_info' },
      { name: 'display_oxxo_tips' },
      { name: 'display_oxxo_total_amount' },
      { name: 'display_oxxo_duedate' },
      { name: 'display_cash_total_value', traits: [] },
      { name: 'display_cash_due_date', traits: [] },
      { name: 'display_cash_barcode', traits: [] },
      { name: 'display_cash_number', traits: [] },
      { name: 'action_cash_download', traits: [] },
      { name: 'action_cash_save_pdf', traits: [] },
      { name: 'display_cash_email_warning', traits: [] },
      { name: 'display_cash_instructions', traits: [] },
      { name: 'display_cash_tips', traits: [] },
      { name: 'display_paynet_payment_locations', traits: [] },
      { name: 'display_cash_puntos', traits: [] },
      { name: 'display_cash_total_amount' },
      { name: 'display_cash_duedate' },
      { name: 'display_spei_success_message' },
      { name: 'display_spei_total_amount' },
      { name: 'display_spei_due_date' },
      { name: 'display_spei_reference_number' },
      { name: 'display_spei_destination_clabe_number' },
      { name: 'display_spei_destination_bank' },
      { name: 'display_spei_destination_beneficiary' },
      { name: 'action_spei_save_pdf' },
      { name: 'display_spei_instructions' },
      { name: 'display_spei_tips' },
      { name: 'field_colombian_document' },
      { name: 'field_colombian_document_type' },
      { name: 'field_colombian_phone_number' },
      { name: 'field_colombian_zipcode' },
      { name: 'field_colombian_state' },
      { name: 'field_colombian_city' },
      { name: 'field_colombian_address' },
      { name: 'field_colombian_street_number' },
      { name: 'field_colombian_street_complement' },
      { name: 'field_chilean_document' },
      { name: 'field_chilean_phone_number' },
      { name: 'field_chilean_zipcode' },
      { name: 'field_chilean_state' },
      { name: 'field_chilean_city' },
      { name: 'field_chilean_address' },
      { name: 'field_chilean_street_number' },
      { name: 'field_chilean_street_complement' },
      { name: 'field_bolivian_phone_number' },
      { name: 'display_webpay_instructions' },
      { name: 'display_webpay_other_methods' },
      { name: 'display_sencillito_instructions' },
      { name: 'display_sencillito_other_methods' },
      { name: 'field_peruvian_document' },
      { name: 'field_peruvian_phone_number' },
      { name: 'field_peruvian_zipcode' },
      { name: 'field_peruvian_state' },
      { name: 'field_peruvian_city' },
      { name: 'field_peruvian_address' },
      { name: 'field_peruvian_street_number' },
      { name: 'field_peruvian_street_complement' },
      { name: 'display_pagoefectivo_instructions' },
      { name: 'display_pagoefectivo_other_methods_tip' },
      { name: 'display_safetypay_cash_instructions' },
      { name: 'display_safetypay_cash_banks' },
      { name: 'display_safetypay_cash_other_methods_tip' },
      {
        name: 'display_card_accepts_brand',
        traits: ['mastercard', 'visa', 'elo', 'amex', 'hipercard', 'carnet', 'magna', 'naranja', 'cabal', 'oca', 'lider', 'creditel', 'walmart'],
      },
      {
        name: 'display_alternative_card_accepts_brand',
        traits: ['mastercard', 'visa', 'elo', 'amex', 'hipercard'],
      },
      {
        name: 'display_debit_card_accepts_brand',
        traits: ['mastercard', 'visa', 'bancodobrasil', 'santander', 'nubank', 'caixa'],
      },
      { name: 'display_brazilian_debitcard_banks_info', traits: [] },
      {
        name: 'display_tef_bank_accepts_brand',
        traits: ['bancodobrasil', 'banrisul', 'bradesco', 'caixa', 'itau', 'santander'],
      },
      { name: 'field_colombian_bank_list' },
      { name: 'display_servipag_instructions', traits: [] },
      { name: 'display_servipag_other_methods', traits: [] },
      { name: 'display_pagoefectivo_total_value' },
      { name: 'display_pagoefectivo_due_date' },
      { name: 'display_pagoefectivo_cip_code' },
      { name: 'action_pagoefectivo_save_cip_as_pdf' },
      { name: 'display_safetypay_online_instructions' },
      { name: 'display_safetypay_online_banks' },
      { name: 'display_safetypay_online_other_methods_tip' },
      { name: 'display_pagosnet_total_value' },
      { name: 'display_pagosnet_due_date' },
      { name: 'display_pagosnet_success_message' },
      { name: 'display_pagosnet_number' },
      { name: 'action_pagosnet_save_pdf' },
      { name: 'display_pagosnet_tip' },
      { name: 'display_pagosnet_merchant_info' },
      { name: 'display_argentine_cash_total_value' },
      { name: 'display_argentine_cash_due_date' },
      { name: 'display_argentine_cash_barcode' },
      { name: 'display_argentine_cash_number' },
      { name: 'display_argentine_cash_tips' },
      { name: 'action_argentine_cash_save_pdf' },
      { name: 'display_argentine_cash_merchant_info' },
      { name: 'display_argentine_cash_information' },
      { name: 'field_ecuadorian_phone_number' },
      { name: 'field_ecuadorian_document' },
      { name: 'field_captcha_token' },
      {
        name: 'display_ewallet_accepts_brand',
        traits: ['mercadopago', 'picpay', 'ame', 'paypal'],
      },
      { name: 'display_efecty_total_value' },
      { name: 'display_efecty_due_date' },
      { name: 'display_efecty_voucher_code' },
      { name: 'field_uruguayan_document' },
      { name: 'field_uruguayan_zipcode' },
      { name: 'field_uruguayan_phone_number' },
      { name: 'field_uruguayan_state' },
      { name: 'field_uruguayan_city' },
      { name: 'field_uruguayan_address' },
      { name: 'field_uruguayan_street_number' },
      { name: 'field_uruguayan_street_complement' },
    ],
  },
};

export default volcanes;
